import { useEffect, useState } from "react";
import SelectTemplateLoader from "./SelectTemplateLoader";
import right from "../images/charm_tick.svg";

const TemplateOptionsComp = ({ setOpenDropdown, templateData, tempId, NoteId, updateNotesTemp = () => {} }) => {
   const [selectedValue, setSelectedValue] = useState(tempId);
   useEffect(() => {
      window.addEventListener("click", onClickOutSide);
      return () => {
         window.removeEventListener("click", onClickOutSide);
      };
   }, []);
   const onClickOutSide = (e) => {
      const condition =
         document.getElementById("switchAccountDroupdown") &&
         document.getElementById("switchAccountDroupdown").contains(e?.target);
      if (!condition) {
         setOpenDropdown(false);
      }
   };
   const handleRadioChange = (templateId) => {
      setOpenDropdown(false);
      updateNotesTemp({ id: NoteId, templateId: templateId });
      setSelectedValue(templateId);
   };

   return (
      <div id="switchAccountDroupdown" className="epic-custom-dropdown-epic">
         <div className="w-100 ">
            {/* <div className="select-dropdown-text py-3">Select template</div> */}
            {templateData?.loading ? (
               <SelectTemplateLoader count={3} fullWidth="94%" sklettenMargen="4" sklettenPading="3" />
            ) : (
               <div className="epic-temp-option-container scrollbar-notes">
                  {templateData?.list?.map((item, index) => {
                     const isSelected = item.id === tempId;
                     const isfirst = index === 0;
                     return (
                        <div key={item?.id} className={`${isfirst && "mt-3"}`}>
                           <div className={`${!isfirst && "border-bottom border epic-border-margin"}`}></div>
                           <div
                              value={item.id}
                              onClick={() => handleRadioChange(item?.id)}
                              className="cursor-pointer d-relative epic-selected-temp-flex  d-flex justify-content-start align-items-center py-4"
                           >
                              {isSelected && <img src={right} alt={right} className="epic-right-sign" />}
                              <div
                                 className={` ${
                                    isSelected ? "dropdown-temp-text" : "unselected-dropdown-temp-text"
                                 } pl-1 text-truncate`}
                              >
                                 {item?.title || "Clinical note"}
                              </div>
                           </div>
                        </div>
                     );
                  })}
               </div>
            )}
         </div>
      </div>
   );
};

export default TemplateOptionsComp;
